import {
    UserAvatars,
    UserInventoryObject,
    UserSkillObjectSingle,
} from "../../Types/DataTypes";
import {
    LeaderboardUser,
    LeaderboardUserImageAndName,
    LeaderboardUserImage,
    LeaderboardUserName,
    LeaderboardUserLevel,
} from "./LeaderboardStyle";
import {
    UserContainer,
    UserCard,
    UserCardTitleAndXP,
    UserCardTitleAndCoins,
    UserCardTitle,
    UserCardCoinsImageAndAmount,
    UserCardCoins,
    UserCardCoinsAmount,
    UserCardItem,
    UserCardItemAmount,
    UserCardItemName,
    UserCardXP,
    UserCardXPName,
    UserCardXPValue,
    UserInventoryDisplay,
} from "./LeaderboardUserComponentStyle";

import { useEffect, useState } from "react";

import CoinStack from "../../Icons/Coins.png";

interface UserComponentProps {
    userObject: UserSkillObjectSingle;
    appropriateName: string;
    avatarObject: UserAvatars | undefined;
    inventoryObject: UserInventoryObject | undefined;
    whichSkillToDisplay: string;
}

export const LeaderboardUserComponent: React.FC<UserComponentProps> = (
    props
) => {
    const [showCard, setShowCard] = useState<boolean>(false);
    const [playAnimation, setPlayAnimation] = useState<boolean>(false);
    const [manyItems, setManyItems] = useState(false);

    const handleUserClick = (e: React.MouseEvent<HTMLDivElement>) => {
        setShowCard(!showCard);
        setPlayAnimation(true);
    };

    const endingAnimation = () => {
        setPlayAnimation(false);
    };

    useEffect(() => {
        let filteredInventory = [];
        if (props.inventoryObject) {
            filteredInventory = Object.keys(
                props.inventoryObject?.[0].items
            ).filter((item) => props.inventoryObject?.[0].items[item] !== 0);
        }
        props.inventoryObject
            ? filteredInventory.length > 23
                ? setManyItems(true)
                : setManyItems(false)
            : setManyItems(false);
    }, [props.inventoryObject]);

    return (
        <UserContainer>
            <LeaderboardUser
                onClick={(e: React.MouseEvent<HTMLDivElement>) =>
                    handleUserClick(e)
                }
            >
                <LeaderboardUserImageAndName>
                    <LeaderboardUserImage
                        src={props.avatarObject?.[0].avatar}
                    />
                    <LeaderboardUserName>
                        {props.appropriateName}
                    </LeaderboardUserName>
                </LeaderboardUserImageAndName>
                <LeaderboardUserLevel>
                    {props.userObject.skills[props.whichSkillToDisplay]}
                </LeaderboardUserLevel>
            </LeaderboardUser>
            <UserCard
                $show={showCard}
                $animate={playAnimation}
                onAnimationEnd={() => endingAnimation()}
            >
                <UserCardTitleAndXP>
                    <UserCardTitleAndCoins>
                        <UserCardTitle>Inventory</UserCardTitle>
                        <UserCardCoinsImageAndAmount>
                            <UserCardCoins src={CoinStack} />
                            <UserCardCoinsAmount>
                                {props.inventoryObject
                                    ? Number(
                                          props.inventoryObject[0].items[
                                              "coins"
                                          ]
                                      ).toLocaleString()
                                    : ""}
                            </UserCardCoinsAmount>
                        </UserCardCoinsImageAndAmount>
                    </UserCardTitleAndCoins>
                    <UserCardXP>
                        <UserCardXPValue>
                            {Number(
                                props.userObject.skills[
                                    props.whichSkillToDisplay.split("_")[0] +
                                        "_xp"
                                ]
                            ).toLocaleString()}{" "}
                            xp
                        </UserCardXPValue>
                        <UserCardXPName>
                            {props.whichSkillToDisplay.split("_")[0]}
                        </UserCardXPName>
                    </UserCardXP>
                </UserCardTitleAndXP>
                <UserInventoryDisplay>
                    {props.inventoryObject
                        ? Object.keys(props.inventoryObject[0].items).map(
                              (key) => {
                                  return props.inventoryObject?.[0].items[
                                      key
                                  ] !== 0 ? (
                                      <UserCardItem
                                          key={key}
                                          $manyItems={manyItems}
                                      >
                                          <UserCardItemName>
                                              {key}
                                          </UserCardItemName>
                                          <UserCardItemAmount>
                                              {Number(
                                                  props.inventoryObject?.[0]
                                                      .items[key]
                                              ).toLocaleString()}
                                          </UserCardItemAmount>
                                      </UserCardItem>
                                  ) : (
                                      ""
                                  );
                              }
                          )
                        : ""}
                </UserInventoryDisplay>
            </UserCard>
        </UserContainer>
    );
};
